// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2PCxD","inner":"Form_inner__d9YvY","range":"Form_range__2nVGA","name":"Form_name__1_WaJ","actions":"Form_actions__2FigS"};